import { render, staticRenderFns } from "./PersonList.vue?vue&type=template&id=1643274b&"
import script from "./PersonList.vue?vue&type=script&lang=ts&"
export * from "./PersonList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports